export const permute = <T>(inputArr: T[], level: number) => {
	const result: T[][] = [];

	const permute = (arr: T[], m: T[] = []) => {
		if (m.length === level) {
			result.push(m);
		} else {
			for (let i = 0; i < arr.length; i++) {
				const curr = arr.slice();
				const next = curr.splice(i, 1);
				permute(curr.slice(), m.concat(next));
			}
		}
	};

	permute(inputArr);

	return result;
};
